module.exports = function (Component) {
  Component.options.__i18n = Component.options.__i18n || []
  Component.options.__i18n.push('{"th":{"claim.claim_files":"ไฟล์ประกอบการยื่นเคลม","claim.claim_files.description":"ถ้ามีการเปิด Ticket เพื่อปรึกษาการเคลมแล้ว และ  File ประกอบเหมือนกัน ก็ไม่จำเป็นต้อง Upload File ใหม่ เพียงแค่คุณใส่ข้อมูล Ticket ที่เกี่ยวข้องแทน","claim.claim_files.files.label":"รูป/วีดีโอ ประกอบการเคลม","claim.claim_files.others.label":"ไฟล์ประกอบอื่น ๆ เช่น Log Files"}}')
  delete Component.options._Ctor
}
